module.exports = __webpack_public_path__ + "static/media/OS1.2f1b4678.jpg";